import * as angular from "angular";
import {IController} from "angular";

export class AccountVehicleInfoTableCtrl implements IController {

  selectedVehicle: any;
  editVehicle: any;
}

angular
  .module('bringoz.admin.accounts')
  .component('accountVehicleInfoTable', {
    bindings: {
      selectedVehicle: '<',
      editVehicle: '<?'
    },
    template: require('./account-vehicle-info-table.html').default,
    controller: AccountVehicleInfoTableCtrl
  });
